module Meevo.Plugins.Manufacturers {
  "use strict";

  /**
  * Main Section of Manufacturer 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Manufacturer> {

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
      createSectionModelInstance(postAdd: (data: any) => any): void {
          this.dataService.getTemplate("manufacturer").then((data) => {
              this.model = data;
              this.model.locationOverride = { locations: [] };
          });
      }
   
  }

}